import styled, { css } from 'styled-components';

export const DateSelectorWrapper = styled.div`
  width: 340px;
`;
